import { z } from "zod";

/**
 * Commands the dashboard sends to a HedgePair Durable Object over the
 * WebSocket upgrade. Every message is a discriminated union on `type`.
 *
 * All state-changing commands flow through the HedgeExecution workflow so
 * the audit log always captures them.
 */
export const PositionCloseCmdZ = z.object({
  type: z.literal("position:close"),
  payload: z.object({
    account: z.string(),
    ticket: z.union([z.number().int(), z.literal("all")]),
  }),
});

export const PositionOpenCmdZ = z.object({
  type: z.literal("position:open"),
  payload: z.object({
    account: z.string(),
    symbol: z.string(),
    side: z.enum(["buy", "sell"]),
    lots: z.number().positive(),
  }),
});

export const HedgeOpenCmdZ = z.object({
  type: z.literal("hedge:open"),
  payload: z.object({
    pair: z.string(),
    symbol: z.string(),
    lots: z.number().positive(),
    buyAccount: z.string(),
    sellAccount: z.string(),
    slDistancePrice: z.number().positive(),
    tpDistancePrice: z.number().positive(),
  }),
});

export const PositionModifyCmdZ = z.object({
  type: z.literal("position:modify"),
  payload: z.object({
    account: z.string(),
    ticket: z.number().int(),
    stopLoss: z.number().nullable(),
    takeProfit: z.number().nullable(),
  }),
});

export const HedgeExtractCmdZ = z.object({
  type: z.literal("hedge:extract"),
  payload: z.object({ pair: z.string() }),
});

export const HedgePauseCmdZ = z.object({
  type: z.literal("hedge:pause"),
  payload: z.object({ pair: z.string() }),
});

export const HedgeResumeCmdZ = z.object({
  type: z.literal("hedge:resume"),
  payload: z.object({ pair: z.string() }),
});

export const DashboardCommandZ = z.discriminatedUnion("type", [
  PositionCloseCmdZ,
  PositionOpenCmdZ,
  HedgeOpenCmdZ,
  PositionModifyCmdZ,
  HedgeExtractCmdZ,
  HedgePauseCmdZ,
  HedgeResumeCmdZ,
]);
export type DashboardCommand = z.infer<typeof DashboardCommandZ>;
